import React from "react";

const items = [
    { kicker: "01", title: "70+ Years Of Academic Legacy" },
    { kicker: "02", title: "AICTE Approved" },
    { kicker: "03", title: "Experienced Faculty" },
    { kicker: "04", title: "Dedicated Placement Support" },
];

export default function Legacy() {
    return (
        <section
            data-testid="legacy-section"
            className="relative py-20 sm:py-24 md:py-32"
            style={{ background: "#f8fafc" }}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-10 sm:gap-12 lg:gap-20 items-start">
                    <div className="lg:col-span-5">
                        <h2
                            className="text-3xl sm:text-4xl md:text-5xl font-bold leading-[1.1] tracking-tight"
                            style={{ color: "#0f172a" }}
                        >
                            A Legacy That
                            <br />
                            <span style={{ color: "#2e326b" }}>Shapes Learning</span>
                        </h2>
                        <div
                            className="mt-6 sm:mt-8 h-[3px] w-16 sm:w-20"
                            style={{ background: "#ffc004" }}
                        />
                    </div>

                    <div className="lg:col-span-7 grid sm:grid-cols-2 gap-x-8 sm:gap-x-10 gap-y-10 sm:gap-y-12">
                        {items.map((item, idx) => (
                            <div
                                key={idx}
                                data-testid={`legacy-item-${idx}`}
                                className="flex items-start gap-4 sm:gap-5 group"
                            >
                                <span
                                    className="text-xs font-mono font-bold tracking-widest pt-2 shrink-0"
                                    style={{ color: "#ffc004" }}
                                >
                                    {item.kicker}
                                </span>
                                <div>
                                    <h3
                                        className="text-lg sm:text-xl md:text-2xl font-semibold leading-snug"
                                        style={{ color: "#0f172a" }}
                                    >
                                        {item.title}
                                    </h3>
                                    <div
                                        className="mt-4 h-px w-10 transition-all duration-500 group-hover:w-20"
                                        style={{ background: "#2e326b" }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
